import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PartnerActions from './partner.actions';
import * as AuthActions from '../auth/auth.actions';
import { catchError, concatMap, filter, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { ContractManagementApiService } from './../../../app/@shared/services/contractmanagementapi.service';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';
import { SessionListResponse } from './../../../app/@shared/models/session_list_response.model';
import { HttpClient } from '@angular/common/http';
import { contractmanagement_api } from '@gridscale/gs-services/contractmanagement_api'; import { ConfigService } from '@gridscale/ingrid/helper/services/config.service';

@Injectable()
export class PartnerEffects {
  readonly #configService = inject(ConfigService);
  constructor(
    private readonly actions$: Actions,
    private contractManagementApi: ContractManagementApiService,
    private publicAPI: PublicPartnerApiService,
    private readonly http: HttpClient,
  ) { }

  loadPartner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnerActions.loadPartner, AuthActions.loginSuccess, PartnerActions.patchPartnerSuccess),
      concatMap(action => {
        return this.http.get<SessionListResponse>(this.#configService.partnerLegacyApi.replace(/\/$/, '') + '/api/v1/').pipe(
          map(result => {
            return PartnerActions.loadPartnerSuccess({
              partner: {
                ...result.partner,
                panel_url: (result.partner.panel_url || '').replace(/\/$/, '')
              },
              partner_config: result.config
            });
          }),
          catchError(error => of(PartnerActions.loadPartnerFailure({ error }), globalFailure({ error })))
        );
      })
    )
  );

  patchPartner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnerActions.patchPartner),
      concatMap(_action =>
        this.publicAPI.patch<void>('/partners/##CURRENT_PARTNER_UUID##', _action.data).pipe(
          map(() => PartnerActions.patchPartnerSuccess()),
          catchError(error => {
            return of(PartnerActions.patchPartnerFailure({ error }), globalFailure({ error }));
          })
        )
      )
    )
  );

  testSmpt$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnerActions.testSmpt),
      concatMap(_action =>
        this.publicAPI.post<void>('/partners/##CURRENT_PARTNER_UUID##/smtp_config_test', _action.data).pipe(
          map(() => PartnerActions.testSmptSuccess()),
          catchError(error => of(PartnerActions.testSmptFailure({ error }), globalFailure({ error })))
        )
      )
    )
  );

  loadPriceListNext$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PartnerActions.loadPartnerContract, AuthActions.loginSuccess),
      concatMap(action => {
        return this.contractManagementApi.get<Partial<contractmanagement_api.PartnerDetailResponse>>('/management/v2/partner', {}).pipe(
          filter(result => result?.data !== undefined),
          map(result => {
            return PartnerActions.loadPartnerContractSuccess({
              partner: result.data!
            });
          }),
          catchError(error => of(PartnerActions.loadPartnerContractFailure({ error }), globalFailure({ error })))
        );
      })
    )
  );
}
